import resources from '../../resources';
export var PROFILE_PASSWORD_SAVING = 'USERS/PROFILE_PASSWORD_SAVING';
export var PROFILE_PASSWORD_SAVE_SUCCESS = 'USERS/PROFILE_PASSWORD_SAVE_SUCCESS';
export var PROFILE_PASSWORD_SAVE_FAILURE = 'USERS/PROFILE_PASSWORD_SAVE_FAILURE';
export function changePassword(data) {
  return function (dispatch) {
    dispatch({
      type: PROFILE_PASSWORD_SAVING
    });
    return resources.auth.password.put(data.currentPassword, data.newPassword).then(function () {
      return dispatch({
        type: PROFILE_PASSWORD_SAVE_SUCCESS
      });
    }).catch(function (error) {
      return dispatch({
        type: PROFILE_PASSWORD_SAVE_FAILURE,
        error: error
      });
    });
  };
}